import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_LOANTERM,
  DELETE_LOANTERM,
  UPDATE_LOANTERM,
  ADD_NEW_LOANTERM,
} from "./actionType";

import {
  getLoanTermSuccess,
  getLoanTermFail,
  deleteLoanTermSuccess,
  deleteLoanTermFail,
  updateLoanTermSuccess,
  updateLoanTermFail,
  addLoanTermSuccess,
  addLoanTermFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveLoanTermApi,
  getLoanTermApi,
  updateLoanTermApi,
  deleteLoanTermApi,
  addNewLoanTermApi
} from "../../helpers/backend_helper";

function* getLoanTerm({ payload: loanTerm }) {
  try {
    const response = yield call(getLoanTermApi, loanTerm);
    yield put(getLoanTermSuccess(GET_LOANTERM, response.data));
  } catch (error) {
    yield put(getLoanTermFail(GET_LOANTERM, error));
  }
}

function* onUpdateLoanTerm({ payload: loanTerm }) {
  try {
    if (loanTerm.setApprove) {
      const response = yield call(approveLoanTermApi, loanTerm);
      yield put(updateLoanTermSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateLoanTermApi, loanTerm);
      yield put(updateLoanTermSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateLoanTermFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteLoanTerm({ payload: loanTerm }) {
  try {
    const response = yield call(deleteLoanTermApi, loanTerm);
    yield put(deleteLoanTermSuccess({ loanTerm, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteLoanTermFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewLoanTerm({ payload: loanTerm }) {
  try {
    const response = yield call(addNewLoanTermApi, loanTerm);
    yield put(addLoanTermSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addLoanTermFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetLoanTerm() {
  yield takeEvery(GET_LOANTERM, getLoanTerm);
}

export function* watchUpdateLoanTerm() {
  yield takeEvery(UPDATE_LOANTERM, onUpdateLoanTerm);
}

export function* watchDeleteLoanTerm() {
  yield takeEvery(DELETE_LOANTERM, onDeleteLoanTerm);
}

export function* watchAddNewLoanTerm() {
  yield takeEvery(ADD_NEW_LOANTERM, onAddNewLoanTerm);
}

function* loanTermSaga() {
  yield all([
    fork(watchGetLoanTerm),
    fork(watchDeleteLoanTerm),
    fork(watchUpdateLoanTerm),
    fork(watchAddNewLoanTerm)
  ]);
}

export default loanTermSaga;
